import { For, splitProps } from "solid-js";
import { ToastGroupViewProps, ToastMessage } from "../model";
import { Toast } from "./toast";
import "../style/toast-group.css";

export function ToastGroup(props: ToastGroupViewProps) {
  const [local, others] = splitProps(props, ["alerts"]);
  return (
    <div {...others} class={`toast-group ${others.class ?? ""}`}>
      <For each={local.alerts.value}>
        {(alert: ToastMessage, index) => {
          const i = index();
          const on_unmount = alert.onUnmount;
          alert.onUnmount = () => {
            if (on_unmount) {
              on_unmount();
            }
            // console.log("removing ", i);
            local.alerts.set((s) => s.filter((a, id) => i !== id));
          };
          return <Toast {...alert} />;
        }}
      </For>
    </div>
  );
}
